const styleElement = document.createElement("dom-module");

styleElement.innerHTML = `<template>
  <style>
    .content {
      border: 1px solid #E5EFFF;
      border-radius: 0px 4px 4px 4px;
      padding: 12px;
      margin-left: 20px;
      margin-top: 6px;
      width: 643px;
    }
    .content .flexbox {
      display: flex;
      justify-content: space-between;
    }
    .content .btn-collapsible {
      height: 24px;
      margin-left: 4px;
      cursor: pointer;
    }
    .content .title-module {
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      color: #424242;
      cursor: pointer;
    }
    .content .title-module-not-registered {
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      color: #424242;
    }
    .content .text-durasi {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #424242;
    }
    .content .text-description {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #424242;
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.2s ease-out;
    }
    p {
      display: block;
      margin-block-start: 0;
      margin-block-end: 0;
    }
    .container-module {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
    }
    .text-is-passed {
      position: absolute;
      left: 30px;
      justify-content: center;
      margin: 20px 0 0.5em 0;
      width: 100px;
      height: 28px;
      font-size: 14px;
      font-weight: 700;
      color: #FFFFFF;
      padding: 4px 12px;
      border-radius: 20px;
      background: #559808;
    }
    .text-is-passed p {
      display: flex;
      justify-content: center;
      margin-top: 1.5px;
    }
    .text-is-failed {
      position: absolute;
      left: 30px;
      justify-content: center;
      margin: 20px 0 0.5em 0;
      width: 100px;
      height: 28px;
      font-size: 14px;
      font-weight: 700;
      color: #FFFFFF;
      padding: 4px 12px;
      border-radius: 20px;
      background: #D0021B;
    }
    .text-is-failed p {
      display: flex;
      justify-content: center;
      margin-top: 1.5px;
    }
    .container-module .view-module {
      display: flex;
      justify-content: center;
      margin: 15px 0 0.5em 0;
      width: 305.5px;
      padding: 8px 12px;
      gap: 4px;
      border: 1px solid #3570D2;
      border-radius: 8px;
      font-weight: 700;
      font-size: 14px;
      color: #3570D2;
      cursor: pointer;
    }
    .title-module-not-registered .icon-content-black {
      width: auto;
      height: 12px;
    }
    .title-module .icon-content-black {
      width: auto;
      height: 12px;
    }
  </style>
</template>`;

styleElement.register("ecourse-module-style");
